import React, { useState } from 'react';
import TestimonialCard from './TestimonialCard';
import Button from '../../../components/ui/Button';

const TestimonialsSection = () => {
  const [activeTab, setActiveTab] = useState('beneficiary');

  const testimonials = {
    beneficiary: [
      {
        id: 1,
        name: "Priya Mendis",
        role: "Student",
        organization: "Ananda College",
        avatar: "https://randomuser.me/api/portraits/women/32.jpg",
        rating: 5,
        content: "The Leo Club's education support program changed my life completely. Thanks to their scholarship and mentoring, I was able to complete my A-Levels and now I'm studying at the University of Colombo. Their members didn't just provide financial help - they became my extended family.",
        project: "Education Support Initiative",
        date: "March 2024"
      },
      {
        id: 2,
        name: "Kamal Perera",
        role: "Small Business Owner",
        organization: "Pettah Market",
        avatar: "https://randomuser.me/api/portraits/men/45.jpg",
        rating: 5,
        content: "During the pandemic, when my small shop was struggling, the Leo Club organized a micro-finance program that helped me restart my business. Today, I employ three people and my family is financially stable again.",
        project: "COVID-19 Economic Recovery",
        date: "January 2024"
      },
      {
        id: 3,
        name: "Sanduni Fernando",
        role: "Community Health Worker",
        organization: "Colombo Municipal Council",
        avatar: "https://randomuser.me/api/portraits/women/28.jpg",
        rating: 5,
        content: "The health awareness campaigns conducted by Leo Club in our community have significantly reduced preventable diseases. Their approach is professional, culturally sensitive, and genuinely caring.",
        project: "Community Health Initiative",
        date: "February 2024"
      }
    ],
    partner: [
      {
        id: 4,
        name: "Dr. Nimal Silva",
        role: "Principal",
        organization: "Royal College Colombo",
        avatar: "https://randomuser.me/api/portraits/men/52.jpg",
        rating: 5,
        content: "Leo Club of Colombo Circle has been our most reliable partner for student development programs. Their leadership workshops and career guidance sessions have benefited over 500 students in the past two years.",
        project: "Youth Leadership Development",
        date: "April 2024"
      },
      {
        id: 5,
        name: "Sister Mary Catherine",
        role: "Director",
        organization: "St. Joseph\'s Orphanage",
        avatar: "https://randomuser.me/api/portraits/women/58.jpg",
        rating: 5,
        content: "The consistency and dedication of Leo Club members is remarkable. They've been supporting our children's education and recreational activities for three years now, never missing a commitment.",
        project: "Children\'s Welfare Program",
        date: "May 2024"
      }
    ],
    member: [
      {
        id: 6,
        name: "Ravindu Jayasinghe",
        role: "Software Engineer",
        organization: "Former President (2022-23)",
        avatar: "https://randomuser.me/api/portraits/men/26.jpg",
        rating: 5,
        content: "Leading Leo Club taught me project management, public speaking, and team leadership skills that directly contributed to my career advancement. I went from junior developer to team lead within two years of my presidency.",
        project: "Personal Development Journey",
        date: "June 2024"
      },
      {
        id: 7,
        name: "Thilini Wickramasinghe",
        role: "Marketing Manager",
        organization: "Current Secretary",
        avatar: "https://randomuser.me/api/portraits/women/24.jpg",
        rating: 5,
        content: "The networking opportunities and leadership experience I've gained through Leo Club are invaluable. I've built lifelong friendships and professional connections that continue to open doors in my career.",
        project: "Leadership Development",
        date: "July 2024"
      }
    ]
  };

  const tabs = [
    { key: 'beneficiary', label: 'Community Beneficiaries', count: testimonials.beneficiary.length },
    { key: 'partner', label: 'Partner Organizations', count: testimonials.partner.length },
    { key: 'member', label: 'Member Stories', count: testimonials.member.length }
  ];

  return (
    <section className="py-16 bg-surface">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl lg:text-4xl font-bold text-foreground mb-4">
            Stories of Impact
          </h2>
          <p className="text-lg text-muted-foreground max-w-3xl mx-auto">
            Real voices from our community sharing how Leo Club of Colombo Circle has made a meaningful difference in their lives.
          </p>
        </div>

        {/* Tab Navigation */}
        <div className="flex flex-wrap justify-center mb-12">
          <div className="bg-card rounded-lg p-1 card-shadow">
            {tabs.map((tab) => (
              <button
                key={tab.key}
                onClick={() => setActiveTab(tab.key)}
                className={`px-6 py-3 rounded-md text-sm font-medium transition-smooth ${
                  activeTab === tab.key
                    ? 'bg-primary text-primary-foreground'
                    : 'text-muted-foreground hover:text-foreground hover:bg-muted'
                }`}
              >
                {tab.label}
                <span className="ml-2 text-xs opacity-75">({tab.count})</span>
              </button>
            ))}
          </div>
        </div>

        {/* Testimonials Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {testimonials[activeTab].map((testimonial) => (
            <TestimonialCard
              key={testimonial.id}
              testimonial={testimonial}
              type={activeTab}
            />
          ))}
        </div>

        <div className="mt-12 text-center">
          <Button variant="outline" iconName="MessageCircle" iconPosition="left">
            Share Your Story
          </Button>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;